"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFormGroupClassNames = exports.FormGroup = void 0;
var React = require("react");
/**
 * An input row, optionally containing a label and having error feedback text.
 *
 * Input is specified in children.
 */
var FormGroup = function (_a) {
    var _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.invalidFeedback, invalidFeedback = _c === void 0 ? null : _c, _d = _a.style, style = _d === void 0 ? undefined : _d, children = _a.children;
    if (label == null) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: "form-group", style: style },
        label && React.createElement("label", { className: classNames.label }, label),
        React.createElement("div", { className: classNames.field },
            children,
            invalidFeedback && React.createElement("div", { className: "invalid-feedback form-text" }, invalidFeedback))));
};
exports.FormGroup = FormGroup;
var classNames = {
    label: "col-md-3",
    field: "col-md-9",
};
function setFormGroupClassNames(p) {
    Object.assign(classNames, p);
}
exports.setFormGroupClassNames = setFormGroupClassNames;
